// extracted by mini-css-extract-plugin
module.exports = {"base":"Button-module--base--FDFyO","light":"Button-module--light--EyB1s","nav":"Button-module--nav--1Ay5h"};